// This function can be used with both gatsby-node and in components and ensures
// that the paths are created the same way during the build and in the frontend.

/**
 * @typedef {{__typename?: 'ContentfulProductCategory', slug: string, id: string, productCategorySections?: {product:{slug: string}}, parents: Array<ProductCategoryLink>}} ProductCategoryLink
 * @typedef {{__typename?: 'ContentfulProduct', id?: string, slug: string, categories: ProductCategoryLink[]}} ProductLink
 */

/**
 * getProductCategoryPath
 * Resolves links to entries of type 'ContentfulProductCategory' in the CMS
 * @param {ProductCategoryLink} category
 * @returns string
 */
const getProductCategoryPath = category => {
  let categorySlug = category && category.slug;
  let parents = category && category.parents;
  let [firstParent] = parents || [];
  let parentPath = firstParent ? `/${firstParent.slug}` : ``; // only for 1 level of nesting ATM

  let path = `/products${parentPath}/${categorySlug}`;
  if (!categorySlug) {
    throw new Error('No category or missing slug');
  }
  return path;
};

/**
 * getProductPath
 * Resolves links to entries of type 'ContentfulProduct' in the CMS
 * @param {ProductLink} product
 * @returns string
 */
const getProductPath = product => {
  let productSlug = product && product.slug;
  if (!productSlug) {
    throw new Error('No product or missing slug');
  }

  return `/products/${productSlug}`;
};

/**
 * getLegacyProductPath
 * Resolves links to entries of type 'Page' in the CMS
 * @param {{slug: string, device: [{slug: string}]}} product
 * @returns string
 */
const getLegacyProductPath = product => {
  let productSlug = product && product.slug;
  if (!productSlug) {
    throw new Error('No product or missing slug');
  }

  let categorySlug = product.device && product.device.length && product.device[0].slug;
  if (!categorySlug) {
    console.warn('Product has no legacy category:', product.slug);
    categorySlug = 'other';
  }
  return `/devices/${categorySlug}/${productSlug}`;
};

module.exports.getProductCategoryPath = getProductCategoryPath;
module.exports.getProductPath = getProductPath;
module.exports.getLegacyProductPath = getLegacyProductPath;
